"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyFormatters = exports.formatCurrencyName = exports.formatCurrencyCode = exports.formatCurrencyLabel = exports.currencyStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var _currencyFormatters;

var currencyStyles = {
  short: 'short',
  long: 'long'
};
exports.currencyStyles = currencyStyles;

var getCurrencySymbol = function getCurrencySymbol(_ref) {
  var code = _ref.code,
      symbol = _ref.symbol,
      symbolNative = _ref.symbolNative;
  var finalSymbol = symbol;

  if (code === symbol && code !== symbolNative) {
    finalSymbol = symbolNative;
  } else if (code === symbol) {
    finalSymbol = '';
  }

  return finalSymbol;
};

var formatCurrencyLabel = function formatCurrencyLabel(currencyCode, currencyStyle) {
  var currencyValue = _I18n.default.currencySymbols[currencyCode];
  var code = currencyValue.code;
  var symbol = getCurrencySymbol({
    code: code,
    symbol: currencyValue.symbol,
    symbolNative: currencyValue.symbol_native
  });

  if (currencyStyle === currencyStyles.short) {
    return code + " " + symbol;
  }

  return currencyValue.name + " (" + code + ") " + symbol;
};

exports.formatCurrencyLabel = formatCurrencyLabel;

var formatCurrencyCode = function formatCurrencyCode(currencyCode) {
  return formatCurrencyLabel(currencyCode, currencyStyles.short);
};

exports.formatCurrencyCode = formatCurrencyCode;

var formatCurrencyName = function formatCurrencyName(currencyCode) {
  return formatCurrencyLabel(currencyCode, currencyStyles.long);
};

exports.formatCurrencyName = formatCurrencyName;
var currencyFormatters = (_currencyFormatters = {}, (0, _defineProperty2.default)(_currencyFormatters, currencyStyles.short, formatCurrencyCode), (0, _defineProperty2.default)(_currencyFormatters, currencyStyles.long, formatCurrencyName), _currencyFormatters);
exports.currencyFormatters = currencyFormatters;